import GoogleAnalyticsService from 'services/GoogleAnalytics';

export default function onGoogleAnalyticsLoad(googleTagId: string) {
  GoogleAnalyticsService.gtag('js', new Date());
  GoogleAnalyticsService.gtag('config', googleTagId);
}
